import styled, { keyframes } from "styled-components";

import { Button, FlexBox, Heading } from "@braze/beacon-core";

const slideInAnimation = keyframes`
0% {
  transform: translateY(-100%);
}
100% {
  transform: translateY(0);
}
`;

export const SalesBannerWrapper = styled(FlexBox)`
  position: sticky;
  top: 0;
  width: 100%;
  min-height: 60px;
  background: #ffeffd;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transition: min-height 0.3s ease;
  animation-duration: 0.3s; /* Shorter duration for pop-out */
  animation-name: ${slideInAnimation};
  animation-delay: 0s; /* Start immediately */
  @media (max-width: 768px) {
    margin-bottom: 0;
  }
  @media (max-width: 500px) {
    min-height: 50px;
  }
`;

export const StyledHeading = styled(Heading)`
  color: #230041;
  @media (max-width: 500px) {
    font-size: 14px;
  }
`;

export const StyledButton = styled(Button)`
  color: #230041;
  font-size: 18px;
  text-decoration: underline;
  @media (max-width: 500px) {
    font-size: 14px;
  }
`;
